import { render, staticRenderFns } from "./ClinicNurseDashboardBottom.vue?vue&type=template&id=04341976&"
import script from "./ClinicNurseDashboardBottom.vue?vue&type=script&lang=js&"
export * from "./ClinicNurseDashboardBottom.vue?vue&type=script&lang=js&"
import style0 from "./ClinicNurseDashboardBottom.vue?vue&type=style&index=0&id=04341976&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports